import { Route, Routes } from 'react-router-dom';
import AgentDashboard from '@/features/agent-dashboard/pages/AgentDashboard';
import DashboardLayout from '@/layouts/dashboard';
import AuthGuard from '@/guards/AuthGuard';
import RoleBasedGuard from '@/guards/RoleBasedGuard';
import DefaultRedirect from '@/routes/DefaultRedirect';

export const AppRoutes = () => (
  <Routes>
    <Route
      element={
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      }
    >
      <Route
        index
        element={
          <RoleBasedGuard roles={['reports.view']}>
            <AgentDashboard />
          </RoleBasedGuard>
        }
      />
      <Route path="*" element={<DefaultRedirect />} />
    </Route>
  </Routes>
);
